<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <v-simple-table fixed-header height="300px">
          <template v-slot:default>
            <thead>
              <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Building</th>
                  <th class="text-left">Floor</th>
                  <th class="text-left">Type</th>
                  <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in spaces" :key="s.mitId">
                <td>
                    <a target="_blank" rel="noopener noreferrer" :href="spacesUrl+s.locationUrl">
                        <h4 class="pt-5">
                            {{s.name || s.mitId}}
                        </h4>

                    </a>
                </td>
                <td>{{ s.buildingMitId }}</td>
                <td>{{ s.level }}</td>
                <td>{{ s.useType }}</td>
                <td><v-btn class="" text outlined color="primary" elevation="0" @click="">Reserve</v-btn></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
    </v-container>
  </div>
</template>

<script>
  import MitSpacesApiService from '../../base/services/BaseMitReserveSpacesService.js';
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitAllSpacesList',
    components: {
    },
    data: function() {
      return {
          spaces:[],
          spacesURL:null
      }
    },
    created() {
      this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');
    },
    mounted() {
      this.getSpaces();
    },
    methods: {
        getSpaces(){
                MitSpacesApiService.getReservableSpaces()
                  .then((data) => {
                      this.spaces = data.spaces
                  })
                  .catch((error) => {
                      console.log('ERROR:', error);
                  });
        }
    }
  }
</script>

<style lang="scss" scoped>
</style>
